import { render, staticRenderFns } from "./AddAttributeOptionComponent.vue?vue&type=template&id=727117c3&"
import script from "./AddAttributeOptionComponent.vue?vue&type=script&lang=js&"
export * from "./AddAttributeOptionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports